import GenericService from "./GenericService";

export default class DocumentImageService extends GenericService{

    static visualizarDocumento = (mapping, docId) => {        
        const url = `${process.env.REACT_APP_API_URL}/api/documents/${mapping}/${docId}`
        window.open(url,'_blank','toolbar=yes')
    }
}